import { render, staticRenderFns } from "./ReceiveIndex.vue?vue&type=template&id=bac1626a"
import script from "./ReceiveIndex.vue?vue&type=script&lang=js"
export * from "./ReceiveIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports